import type { ApiResponse } from '@library/services'

export function parseResponse<T>(
  response: ApiResponse<T>
): ApiResponse<T>['data'] {
  return response.data
}
